/* Three chart cards side by side, so one date stands at one x across the row and the shared
 * crosshair reads as one vertical line. Promoted out of `pages/client-detail/ui/DetailTab.module.css`
 * on 4 November 2026 on its second consumer, `features/survey-report`'s chart strip. */

.chartGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-5);
  align-items: stretch;
}
